import { render } from "./ExhibitionsView.vue?vue&type=template&id=f9c221ce&scoped=true"
import script from "./ExhibitionsView.vue?vue&type=script&lang=js"
export * from "./ExhibitionsView.vue?vue&type=script&lang=js"

import "./ExhibitionsView.vue?vue&type=style&index=0&id=f9c221ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c221ce"]])

export default __exports__